import React from 'react';

const StudentSymposium: React.FC = () => {
  return (
    <div className="text-justify py-4">
      <p className="mb-4">
        Pada ajang <b>Indonesia Innovative Technology Challenge (IIT Challenge) 2024</b>, kategori <b>Student Symposium Research Paper</b> menghadirkan kesempatan bagi siswa SMP dan SMA untuk menyuarakan gagasan mereka melalui penelitian. Dengan tema seputar <b>pandemi COVID-19 dan Sustainable Development Goals (SDGs)</b>, peserta diajak untuk menggali isu-isu penting dunia dan mencari solusi inovatif.
      </p>
      
      <h2 className="text-2xl font-bold mb-4 mt-6">Penelitian yang Menginspirasi</h2>
      <p className="mb-4">
        Kategori ini dirancang untuk mengasah kemampuan berpikir kritis, analitis, dan komunikatif siswa. Peserta bebas memilih salah satu dari dua tema besar:
      </p>
      
      <ol className="list-decimal pl-6 mb-6 space-y-4">
        <li>
          <p><strong>Pandemi COVID-19</strong></p>
          <p>
            Penelitian tentang dampak pandemi terhadap pendidikan, ekonomi, atau kesehatan masyarakat.
          </p>
        </li>
        <li>
          <p><strong>Sustainable Development Goals (SDGs)</strong></p>
          <p>
            Pemilihan tema peserta pada salah satu dari 17 tujuan SDGs, seperti pendidikan berkualitas (Goal 4), energi bersih (Goal 7), atau aksi iklim (Goal 13).
          </p>
        </li>
      </ol>
      
      <h2 className="text-2xl font-bold mb-4 mt-6">Pengalaman dari Student Symposium Research Paper</h2>
      
      <ol className="list-decimal pl-6 mb-6 space-y-4">
        <li>
          <p><strong>Mengasah Kemampuan Penelitian</strong></p>
          <p>
            Peserta belajar melakukan penelitian mendalam, mengumpulkan data, dan menarik kesimpulan berdasarkan fakta.
          </p>
        </li>
        <li>
          <p><strong>Melatih Kemampuan Presentasi</strong></p>
          <p>
            Para peserta mempresentasikan hasil penelitian mereka di hadapan juri dan audiens, melatih kepercayaan diri dan kemampuan komunikasi.
          </p>
        </li>
        <li>
          <p><strong>Memahami Masalah Global</strong></p>
          <p>
            Melalui tema seperti COVID-19 dan SDGs, peserta diajak untuk memahami isu-isu global dan mencari solusi yang relevan.
          </p>
        </li>
      </ol>
      
      <h2 className="text-2xl font-bold mb-4 mt-6">Membangun Pemimpin Masa Depan</h2>
      <p className="mb-6">
        Kompetisi <b>Student Symposium Research Paper</b> tidak hanya menampilkan karya-karya terbaik para siswa, tetapi juga mempersiapkan mereka untuk menjadi pemimpin masa depan yang mampu berpikir kritis dan memberikan solusi nyata untuk masalah global.
      </p>
      
      <h2 className="text-2xl font-bold mb-4 mt-6">Yuk, Jelajahi Keseruan IIT Challenge!</h2>
      <p className="mb-4">
        Untuk informasi lebih lanjut dan momen seru lainnya dari IIT Challenge 2024, kunjungi Instagram kami di <a href="https://instagram.com/iitchallenge2024" target='_blank' className="underline font-semibold text-defaultBlue">@iitchallenge2024</a>.
      </p>
      <p>
        Temukan inspirasi dari karya-karya luar biasa generasi muda Indonesia dan persiapkan dirimu untuk tantangan selanjutnya! <span className='font-bold'>Mari dukung anak-anak Indonesia untuk terus berkarya dan menjadi inovator masa depan!</span>
      </p>
    </div>
  );
};

export default StudentSymposium;